import camelCase from "lodash/camelCase";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const files = require.context("./modules", false, /\.js$/i);
const modules = {};

files.keys().forEach((item) => {
  const name = camelCase(item.slice(2, -3));
  const fileModule = files(item).default;
  if (!fileModule) return;
  modules[name] = fileModule;
});

export default new Vuex.Store({
  modules,
});
